export default __webpack_public_path__ + "static/bg-eeecdd64200a2fe753dabcec71a6b77a.png";